import { IAuthDataF3BusRequestDTO, IAuthDataViewDTO } from "../../coreapi-dto/service/authData";
import { ContentType } from "../../fetchApiDistributor/contentTypes";
import { CoreApiResponse, IRequestEventHandler } from "../common";
import { BaseDirRequest } from "../dirs/baseDirRequest";

export class AuthDataRequest extends BaseDirRequest<IAuthDataViewDTO, IAuthDataViewDTO> {
    constructor(baseUrl: string, token: string, eventHandler: IRequestEventHandler) {
        super(baseUrl, "ExtSources/AuthData", token, eventHandler);
    }

    create(body: IAuthDataViewDTO, callback: (e: CoreApiResponse<string>) => void) {
        this.post<string>(
            `${this._baseUrl}/${this._routePrefix}`,
            body,
            this.getHeaders(),
            (e) => {
                this._eventHandler?.onGetResponse(e);
                callback?.(e);
            },
        );
    }

    createF3Bus(body: IAuthDataF3BusRequestDTO, callback?: (e: CoreApiResponse<string[]>) => void) {
        this.post<string[]>(
            `${this._baseUrl}/${this._routePrefix}/F3Bus`,
            body,
            this.getHeaders(),
            (e) => {
                this._eventHandler?.onGetResponse(e);
                callback?.(e);
            },
        );
    }

    getServiceName(serviceName: string, callback?: (e: CoreApiResponse<IAuthDataViewDTO>) => void) {
        this.get<IAuthDataViewDTO>(`${this._baseUrl}/${this._routePrefix}/ServiceName/${serviceName}`, [this.getBearerHeader(this._token)], (e) => {
            if (this._eventHandler) {
                if (e.respType === "isFailed") {
                    this._eventHandler.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            }
        })
    }

    getClientName(clientName: string, callback?: (e: CoreApiResponse<IAuthDataViewDTO>) => void) {
        this.get<IAuthDataViewDTO>(
            `${this._baseUrl}/${this._routePrefix}/ClientName/${encodeURIComponent(clientName)}`,
            [this.getBearerHeader(this._token)],
            (e) => {
                if (e.respType === "isFailed") {
                    this._eventHandler?.onGetResponse(e);
                } else {
                    callback?.(e);
                }
            },
        );
    }

    private getHeaders(): string[][] {
        return this.concatHeaders(
            [this.getBearerHeader(this._token)],
            [ContentType.ApplicationJson],
        );
    }

}

export default AuthDataRequest;
